import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import { CountrycheckComponent } from '../../taskcost/countrycheck/countrycheck.component';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/services/data.service';
import { ConfirmDialog } from '../../taskcost/confirmdialog';
import { dollarUS, feedsConfig, HSI_EMBARGO_AMOUNT, OPTICAL_EMBARGO_AMOUNT, SAR_EMBARGO_AMOUNT, STEREO_EMBARGO_AMOUNT, Video_EMBARGO_AMOUNT } from 'src/app/services/constants';
import { UtilsService } from 'src/app/services/utils.service';
import { TaskAgreementDialogComponent } from '../task-agreement-dialog/task-agreement-dialog.component';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { catchError, EMPTY, map, switchMap, firstValueFrom } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { PopupService } from 'src/app/services/popup.service';
import { WarningPopupComponent } from '../warning-popup/warning-popup.component';
var geoParse = require('wellknown');

interface WeatherCostResponse {
  weather_ex_cost: number;
  weather_ex_point?: number;
  [key: string]: any;
}

@Component({
  selector: 'CreateTaskConfirmDialog',
  templateUrl: 'confirmdialog.html',
  styleUrls: ['confirmdialog.scss'],
})
export class CreateTaskConfirmDialog implements OnInit {
  private readonly smallBoatLatencyLimitHours = 24 * 7;
  private smallBoatWarningShown = false;
  private confirmedWeatherFeedIds = new Set<string>();
  message = '';
  latitude = '';
  longitude = '';
  task: any;
  title = 'Create New Task';
  newTaskForm: any = FormGroup;
  outComeError: boolean = true;
  outComesensor: any;
  outComeSubmit: boolean = false;
  confirmDialogData: any = null;
  demoView: boolean = false;
  SensorsTypes:any = [];
  filteredSensorTypes: any[];
  allocatedSensorTypes: Set<string> = new Set();
  place: any;
  country: any;
  poiWkt: string;
  geoJson: string;
  darkTheme: boolean;
  tooltipImagePath: string;
  openWater: boolean = false;
  agree: boolean = false;
  opticalValue: any = '';
  sarValue: any = '';
  stereoValue: any = '';
  hsiValue: any = '';
  videoValue: any = '';
  purposeOption: any;
  intentOption: any;
  feedsOption:any;
  selectedFeeds:any;
  isFeedsAvailable:boolean = false;
  isGetResolutionCloudcover:boolean = false;
  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<CreateTaskConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    public dialog: MatDialog,
    private http: HttpClient,
    private dataService: DataService,
    private utilsService: UtilsService,
    private userService: UserService,
    private popupService: PopupService
  ) {
    this.message = data.message;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    this.task = data.task;
    let accuracy = 15;
    this.geoJson = `POINT (${data.longitude.toFixed(accuracy)} ${data.latitude.toFixed(accuracy)})`;
    this.poiWkt = 'Lng: ' + data.longitude.toFixed(accuracy) + '  ' + 'Lat: ' + data.latitude.toFixed(accuracy);
    if (environment.demoView === 'true') {
      this.demoView = true;
    }
    else {
      this.demoView = false;
    }

    this.dataService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;

      this.tooltipImagePath = this.darkTheme ? '../../../assets/images/union-dark.svg' : '../../../assets/images/union.svg';
    });
  
    this.apiService.intentOption().subscribe((response: any) => {
      this.intentOption = response;
    });


    this.newTaskForm = new FormGroup({
      taskName: new FormControl('',[Validators.minLength(5)]),
      sensorType: new FormControl(),
      resolution: new FormControl(),
      cloudCover: new FormControl(),
      target: new FormControl(),
      intent: new FormControl(),
      feeds: new FormControl(),
      latency: new FormControl('', [Validators.required, Validators.min(24), Validators.pattern(/^[0-9]\d*$/)]),
    });

    this.newTaskForm.get('sensorType')?.valueChanges.subscribe((sensor) => {
    if (sensor) {
      this.newTaskForm.get('feeds')?.enable();
      //this.isFeedsAvailable = true;
    } else {
      this.newTaskForm.get('feeds')?.disable();
      this.newTaskForm.get('feeds')?.reset();
      this.isFeedsAvailable = false;
    }
  });
    this.newTaskForm.get('feeds')?.valueChanges.subscribe((feeds) => {
      this.selectedFeeds = feeds;
      this.syncConfirmedWeatherFeeds(feeds);
      this.enforceSmallBoatLatencyLimit();
    });
    this.newTaskForm.get('latency')?.valueChanges.subscribe(() => {
      this.enforceSmallBoatLatencyLimit();
    });
    this.newTaskForm.valueChanges.subscribe(() => {
      if (this.isAnyFieldEmpty()) {
        this.outComeError = true;
      } else {
        this.outComeError = false;
      }
    });

    this.newTaskForm.get('target').setValue(this.geoJson);
    this.getCountryAndPlace(this.latitude,this.longitude);
    this.setEmbargoData();
    this.apiService.getPurpose().subscribe((res: any) => {
      this.purposeOption = this.utilsService.sortPurposeOptions(res?.purposeList);
    });
  }

  async ngOnInit(): Promise<void> {
    await this.fetchAllocatedSensors();
    this.getSensorTypes(this.data?.user?.id);
  }

  isAnyFieldEmpty(): boolean {
    for (const key of Object.keys(this.newTaskForm.controls)) {
       if (key !== 'cloudCover' && key !== 'feeds') {
        const controlValue = this.newTaskForm.get(key).value;
        if (controlValue === null || controlValue === undefined || controlValue === '') {
          return true;
        }
      }

      if (key === 'cloudCover') {
        const controlValue = this.newTaskForm.get(key).value;
        if ((controlValue === null || controlValue === undefined || controlValue === '') && this.outComesensor?.cloudCover?.length > 0) {
          return true;
        }
      }
    }
    return false;
  }

  get fields() {
    return this.newTaskForm.controls;
  }

  sensorChange(event: any) {
    this.newTaskForm.patchValue({
      resolution: '',
      cloudCover: ''
    });

    let intent = 'Internal Use';
    let target = 'POI';

    let sensorObj = {
      sensorType: event.value,
      target: target,
      intent: intent
    }

    this.apiService.getSensorDetails(sensorObj).subscribe((res: any) => {
      this.outComesensor = res;
      const cloudC: any = [];
      if (res.cloudCover) {
        for (var key in res.cloudCover) {
          cloudC.push({ key, value: res.cloudCover[key] });
        }
        this.outComesensor.cloudCover = cloudC;

        if (this.outComesensor?.cloudCover?.length === 0) {
          this.newTaskForm.get('cloudCover').disable();
        } else {
          this.newTaskForm.get('cloudCover').enable();
        }
      }
      this.isGetResolutionCloudcover = true;
    });
    let selectedSensorTypes = [{
      sensor: this.newTaskForm?.value?.sensorType?.name,
    }];
    if (this.data?.user?.user_plan !== 1) {
      this.apiService.getInformationServices(selectedSensorTypes, this.task.taskId, this.openWater).subscribe((response: any) => {
        this.feedsOption = this.getFilteredFeedOptions(response?.informationServices);
        this.isFeedsAvailable = this.feedsOption.length > 0;
        this.confirmedWeatherFeedIds.clear();
      });
    }
  }

  submit() {
    // Build task parameters object
    let newTaskParams: any = {
      project: this.task.project,
      projectid: this.task.projectId,
      aoiCountry: this.country,
      aoiPlace: this.place,
      taskname: this.newTaskForm?.value?.taskName,
      purpose: this.purposeOption[0],
      area: 0,
      target: JSON.stringify(geoParse(this.geoJson)),
      taskStrategy: 'Task From Collection',
      intent: this.newTaskForm?.value?.intent,
      outComeCloudCover: this.newTaskForm?.value?.cloudCover,
      outComeLatency: this.newTaskForm?.value?.latency,
      outComeResolution: this.newTaskForm?.value?.resolution,
      outComesensorType: this.newTaskForm?.value?.sensorType?.name,
      openWater: this.openWater,
      feeds: this.selectedFeeds
    };
  
    this.outComeSubmit = true;
    this.apiService.intentOption().subscribe({
      next: (response: any) => {
        try {
          const internalUseItem = response.find((item: any) => item.intent_key === 'internalUse');
          if (!newTaskParams.intent) {
            newTaskParams.intent = internalUseItem || response[0];
          }
          newTaskParams.outcomeIntent = newTaskParams.intent;
          this.apiService.checkAvailableOperators(newTaskParams).subscribe((res: any) => {
            if(res.msg == 'Failed') {
              this.outComeSubmit = false;
              this.dialog.open(CountrycheckComponent, {
                width: '40%',
                backdropClass: 'blurred',
                disableClose: true,
                data: {
                  message: 'outcomeFail',
                  response: res?.message,
                  url: '/task'
                }
              });
            } else {
              this.dialogRef.close();
              this.openTaskAgreementDialog(newTaskParams)
            }
          })
          
        } catch (error) {
          this.outComeSubmit = false;
        }
      },
      error: (error) => {
        this.outComeSubmit = false;
      }
    });
  }
  
    



  private openTaskAgreementDialog(newTaskParams: any) {
    const dialogRef = this.dialog.open(TaskAgreementDialogComponent, {
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        opticalValue: this.opticalValue,
        sarValue: this.sarValue,
        stereoValue: this.stereoValue,
        hsiValue: this.hsiValue,
        videoValue: this.videoValue,
        isallocatedUser: this.data?.user?.allocated,
      },
    });
  
    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result === 'agree') {
          this.callSubmitApi(newTaskParams);
        } else {
          this.outComeSubmit = false;
        }
      },
      error: (error) => {
        this.outComeSubmit = false;
      }
    });
  }

  callSubmitApi(newTaskParams) {
    this.apiService.intentOption().subscribe((response: any) => {
      const internalUseItem = response.find((item: any) => item.intent_key === 'internalUse');
      if (!newTaskParams['intent']) {
        newTaskParams['intent'] = internalUseItem || response[0];
      }
      newTaskParams['outcomeIntent'] = newTaskParams['intent'];
  
      this.apiService.outcomeTaskSubmit(newTaskParams).subscribe((res: any) => {
        if (res?.msg === 'Success') {
          this.dialogRef.close();
          this.dialog.open(ConfirmDialog, {
            width: '40%',
            backdropClass: 'blurr',
            disableClose: true,
            data: {
              taskid: res?.taskid,
              taskname: newTaskParams['taskname'],
              response: res,
              type: 'maptask',
              from: 'maptask'
            }
          });
        } else {
          this.outComeSubmit = false;
          this.dialog.open(CountrycheckComponent, {
            width: '40%',
            backdropClass: 'blurred',
            disableClose: true,
            data: {
              message: 'outcomeFail',
              response: res?.message,
              url: '/task'
            }
          });
        }
      }, (error: any) => {
        this.outComeSubmit = false;
        this.dialog.open(CountrycheckComponent, {
          width: '40%',
          backdropClass: 'blurred',
          disableClose: true,
          data: { message: 'taskFail', url: '/task' }
        });
      });
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
    this.agree = false;
    this.outComeSubmit = false;
  }

  onClick() {
    this.agree = true;
    if (this.confirmDialogData) {
      this.dialogRef.close();
      this.dialog.open(ConfirmDialog, {
        backdropClass: 'blurr',
        disableClose: true,
        width: '40%',
        data: this.confirmDialogData,
      });
    }
  }

  async onSubmit() {
    const canProceed = await this.validateWeatherFeedsBeforeSubmit();
    if (!canProceed) {
      this.outComeSubmit = false;
      return;
    }

    this.submit();
  }

  getCountryAndPlace(latitude, longitude) {
    const apiKey = environment.openCageApiKey;
    const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKey}`;
    let place: any, country: any, countryCode: any;
    let location = {
      longitude : longitude,
      latitude : latitude
    }

    this.apiService.checkIsWater(location).subscribe((res: any) => {
    this.openWater = res?.water;
    this.http.get(url).subscribe((response: any) => {
      if (response.results.length > 0) {
        const firstResult = response.results[0];
                
        if (firstResult.components?.body_of_water) {
           country = firstResult.components.body_of_water;
           place = firstResult.components.body_of_water;
           countryCode = firstResult.components.body_of_water;
        } else {
           country = firstResult.components.country;
           place = firstResult.components.city || firstResult.components.state || firstResult.components.county;
           countryCode = firstResult.components["ISO_3166-1_alpha-3"];
        }

        this.place = place;
        this.country = country;
      }
    });
  });
  }

  onKeyChange(key): void {
    const keyControl = this.newTaskForm.get(key);
    keyControl?.markAsTouched();
    keyControl?.updateValueAndValidity();
  }

  private enforceSmallBoatLatencyLimit(): void {
    const latencyControl = this.newTaskForm.get('latency');
    const feedsControl = this.newTaskForm.get('feeds');
    const latencyValue = latencyControl?.value;

    if (!latencyValue || !Number.isFinite(Number(latencyValue))) {
      this.smallBoatWarningShown = false;
      return;
    }

    const latencyHours = Number(latencyValue);
    const currentFeeds = feedsControl?.value;

    if (!Array.isArray(currentFeeds) || currentFeeds.length === 0) {
      this.smallBoatWarningShown = false;
      return;
    }

    // Check if any selected feed is small-boat
    const smallBoatFeeds = currentFeeds.filter((feed: any) => {
      const feedId = this.getSelectedFeedId(feed);
      return !!feedId && feedsConfig[feedId]?.type === 'small-boat';
    });

    if (smallBoatFeeds.length === 0) {
      this.smallBoatWarningShown = false;
      return;
    }

    // If latency exceeds limit and warning hasn't been shown yet
    if (latencyHours > this.smallBoatLatencyLimitHours && !this.smallBoatWarningShown) {
      this.smallBoatWarningShown = true;
      const removedFeedIds = new Set(
        smallBoatFeeds
          .map((feed: any) => this.getSelectedFeedId(feed))
          .filter((feedId: string | null): feedId is string => !!feedId)
      );
      const remainingFeeds = currentFeeds.filter((feed: any) => {
        const feedId = this.getSelectedFeedId(feed);
        return !feedId || feedsConfig[feedId]?.type !== 'small-boat';
      });
      feedsControl?.setValue(remainingFeeds, { emitEvent: false });
      this.selectedFeeds = remainingFeeds;
      removedFeedIds.forEach((feedId) => this.confirmedWeatherFeedIds.delete(feedId));

      const message = 'The weather data is only available for the next seven days. The current task with the time of interest (TOI) exceeding the weather data availability could not be accepted at this time. Please change the How Soon? value to be within the next seven days and select the feed again if needed.';
      this.popupService.openPopup(WarningPopupComponent, message, '', '50%');
    } else if (latencyHours <= this.smallBoatLatencyLimitHours) {
      this.smallBoatWarningShown = false;
    }
  }

  private getSelectedFeedId(feed: any): string | null {
    if (!feed) {
      return null;
    }

    if (typeof feed === 'string') {
      return feed;
    }

    return feed._id || feed.id || null;
  }

  private getFilteredFeedOptions(feeds: any): any[] {
    if (!Array.isArray(feeds)) {
      return [];
    }

    return [...feeds];
  }

  private syncConfirmedWeatherFeeds(feeds: any): void {
    if (!Array.isArray(feeds) || feeds.length === 0) {
      this.confirmedWeatherFeedIds.clear();
      return;
    }

    const selectedFeedIds = new Set(
      feeds
        .map((feed: any) => this.getSelectedFeedId(feed))
        .filter((feedId: string | null): feedId is string => !!feedId)
    );

    Array.from(this.confirmedWeatherFeedIds).forEach((feedId) => {
      if (!selectedFeedIds.has(feedId)) {
        this.confirmedWeatherFeedIds.delete(feedId);
      }
    });
  }

  private async validateWeatherFeedsBeforeSubmit(): Promise<boolean> {
    const selectedFeeds = Array.isArray(this.selectedFeeds) ? [...this.selectedFeeds] : [];
    const latencyHours = Number(this.newTaskForm?.get('latency')?.value);

    if (!selectedFeeds.length || !Number.isFinite(latencyHours)) {
      return true;
    }

    const weatherFeeds = selectedFeeds.filter((feed: any) => {
      const feedId = this.getSelectedFeedId(feed);
      return !!feedId && feed?.weatherIncluded && !this.confirmedWeatherFeedIds.has(feedId);
    });

    for (const feed of weatherFeeds) {
      const feedId = this.getSelectedFeedId(feed);
      if (!feedId) {
        continue;
      }

      if (latencyHours > this.smallBoatLatencyLimitHours) {
        this.removeSelectedFeed(feedId);
        return false;
      }

      const proceedWithWeatherCost = await this.showWeatherCostPopup(feed);
      if (proceedWithWeatherCost === null) {
        return false;
      }

      if (!proceedWithWeatherCost) {
        this.removeSelectedFeed(feedId);
        return false;
      }

      this.confirmedWeatherFeedIds.add(feedId);
    }

    return true;
  }

  private async showWeatherCostPopup(feed: any): Promise<boolean | null> {
    const weatherCharge = await this.getWeatherCost(feed);

    if (weatherCharge === null) {
      this.popupService.openPopup(
        WarningPopupComponent,
        'Unable to retrieve the weather cost right now. Please try again.',
        '',
        '50%'
      );
      return null;
    }

    const selectedCharge = this.data?.user?.pointsEligible
      ? Number(weatherCharge?.weather_ex_point || 0)
      : Number(weatherCharge?.weather_ex_cost || 0);

    if (selectedCharge === 0) {
      return true;
    }

    const formattedCost = this.formatWeatherCost(weatherCharge);
    const message = `The selected feed requires weather data. The maximum expected deduction is ${formattedCost} (non-refundable). The platform will add this weather cost to the feed cost if you continue to order the feed.`;

    const dialogRef = this.popupService.openAlert(
      message,
      'warning',
      [
        { text: 'No', value: 'no' },
        { text: 'Yes', value: 'yes', primary: true },
      ],
      '50%',
      { title: 'Confirmation', darkTheme: this.darkTheme }
    );

    const result = await firstValueFrom(dialogRef.afterClosed());
    return result === 'yes';
  }

  private async getWeatherCost(feed: any): Promise<WeatherCostResponse | null> {
    try {
      const feedId = this.getSelectedFeedId(feed);
      if (!feedId) {
        return null;
      }

      const parsedTarget = geoParse(this.geoJson);
      const sensorType = this.newTaskForm?.value?.sensorType?.name;
      const latencyHours = Number(this.newTaskForm?.get('latency')?.value);
      const payload: any = {
        target: parsedTarget,
        hours: latencyHours,
        taskId: this.task?.taskId,
        customerId: this.data?.user?.id,
        feedIds: [feedId],
      };

      if (sensorType) {
        payload.sensorType = sensorType;
      }

      const response = await firstValueFrom(
        this.apiService.getWeatherCostBySelectedFeeds(payload)
      ) as WeatherCostResponse;

      if (response) {
        const weatherCost = Number(response?.weather_ex_cost);
        const weatherPoints = Number(response?.weather_ex_point);

        return {
          weather_ex_cost: Number.isFinite(weatherCost) ? weatherCost : 0,
          weather_ex_point: Number.isFinite(weatherPoints) ? weatherPoints : 0,
        };
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  private formatWeatherCost(weatherCharge: WeatherCostResponse): string {
    if (this.data?.user?.pointsEligible) {
      const weatherPoints = Number(weatherCharge?.weather_ex_point ?? 0);
      return `${weatherPoints} Points`;
    }

    const weatherCost = Number(weatherCharge?.weather_ex_cost ?? 0);
    return `US$ ${weatherCost.toFixed(2)}`;
  }

  private removeSelectedFeed(feedIdToRemove: string): void {
    const currentFeeds = Array.isArray(this.newTaskForm.get('feeds')?.value)
      ? this.newTaskForm.get('feeds')?.value
      : [];
    const remainingFeeds = currentFeeds.filter((feed: any) => this.getSelectedFeedId(feed) !== feedIdToRemove);

    this.newTaskForm.get('feeds')?.setValue(remainingFeeds, { emitEvent: false });
    this.selectedFeeds = remainingFeeds;
    this.confirmedWeatherFeedIds.delete(feedIdToRemove);
    this.syncConfirmedWeatherFeeds(remainingFeeds);
  }

  setEmbargoData() {
    this.opticalValue = dollarUS.format(OPTICAL_EMBARGO_AMOUNT);
    this.sarValue = dollarUS.format(SAR_EMBARGO_AMOUNT);
    this.stereoValue = dollarUS.format(STEREO_EMBARGO_AMOUNT);
    this.hsiValue = dollarUS.format(HSI_EMBARGO_AMOUNT);
    this.videoValue = dollarUS.format(Video_EMBARGO_AMOUNT);


    if (this.data?.user?.pointsEligible) {
      const parts = this.data.user.sensorConversionFactor.split(':');
      const conversionFactor =  parseFloat(parts[1]) / parseFloat(parts[0]);
      this.opticalValue = Math.round(OPTICAL_EMBARGO_AMOUNT * conversionFactor) + ' Points';
      this.sarValue = Math.round(SAR_EMBARGO_AMOUNT * conversionFactor) + ' Points';
      this.stereoValue = Math.round(STEREO_EMBARGO_AMOUNT * conversionFactor) + ' Points';
      this.hsiValue = Math.round(HSI_EMBARGO_AMOUNT * conversionFactor) + ' Points';
      this.videoValue = Math.round(Video_EMBARGO_AMOUNT * conversionFactor) + ' Points';
    }
  }
  async fetchAllocatedSensors(): Promise<void> {
    try {
      const userSubs = this.data?.user?.subscriptionType || 'standard';
      const intentOptions = await firstValueFrom(this.apiService.intentOption());
      const internalUseIntent = intentOptions.find((item: any) => item.intent_key === 'internalUse');
      const intent = internalUseIntent?._id || intentOptions[0]?._id;

      const sensorResult: any = await firstValueFrom(
        this.userService.getSensors(userSubs, this.data?.user?.id, intent, {})
      );
      const allOperators = sensorResult?.[0]?.operators || [];

      // Store allocated sensor types for filtering
      this.allocatedSensorTypes = new Set(allOperators.map(op => op.sensortype).filter(Boolean));
    } catch (error) {
      console.error('Error fetching allocated sensors:', error);
      // On error, leave allocatedSensorTypes empty to show all sensors
    }
  }

  getSensorTypes(userId: string) {
    this.apiService.getOutcomeSensorTypes(userId).subscribe((res: any) => {
      if (res) {
        this.SensorsTypes = this.apiService.SENSORSTYPE.filter(sensor =>
          res?.sensorTypes.includes(sensor.value)
        );        
      }
      // Filter by feasibility and hide sensor types not applicable to collections
      this.filteredSensorTypes = this.SensorsTypes.filter(item => item.feasibility === true && !item.hideInCollections);
      
      // Additionally filter by allocated sensor types (for Plan 4 users)
      // If allocatedSensorTypes is not empty, only show sensor types that are allocated
      if (this.allocatedSensorTypes.size > 0) {
        this.filteredSensorTypes = this.filteredSensorTypes.filter(item => 
          this.allocatedSensorTypes.has(item.value)
        );
      }
    });
  }
  close(mySelect: MatSelect, event: Event): void {
    event.stopPropagation(); // Prevent propagation
    mySelect.close(); // Close the dropdown
  }
}
